export default __webpack_public_path__ + "static/media/template_business-man__0000_Layer-2.175bd032.png";